var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "no-ssr",
        [
          _c("message-toast-wrapper"),
          _vm._v(" "),
          _vm.loggedIn ? _c("system-menu") : _vm._e(),
          _vm._v(" "),
          _c("progress-loader"),
          _vm._v(" "),
          _vm.loggedIn ? _c("media-manager") : _vm._e(),
          _vm._v(" "),
          _c(
            "AModal",
            {
              attrs: { size: "sm" },
              model: {
                value: _vm.loginModalVisible,
                callback: function ($$v) {
                  _vm.loginModalVisible = $$v
                },
                expression: "loginModalVisible",
              },
            },
            [
              _c("login-subform", {
                attrs: { "show-create-account": true },
                on: {
                  loginInProgress: _vm.hideLoginModal,
                  toggle: _vm.hideLoginModal,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "AModal",
            {
              attrs: { size: "sm" },
              model: {
                value: _vm.onRequestModalVisible,
                callback: function ($$v) {
                  _vm.onRequestModalVisible = $$v
                },
                expression: "onRequestModalVisible",
              },
            },
            [
              _vm.formItem.form
                ? _c("form-renderer", {
                    attrs: { form: _vm.formItem },
                    on: {
                      success: _vm.formSubmissionSucceed,
                      failure: _vm.formSubmissionFailed,
                    },
                  })
                : [
                    _vm._v(
                      "\n        " + _vm._s(_vm.noFormMessage) + "\n      "
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }